import { InputSwitch } from 'primereact/inputswitch';

const SfSwitch = (props) => {
  const classes = props.styling ? props.styling : "";

  return <InputSwitch {...props} className={classes} />;
};

export default SfSwitch;
